import { FlexBox, Icon, Skeleton, Text } from '@dixa/lib-shared-habla';
import { typography } from '@dixa/lib-shared-tokens';
import { convertChannelCasing } from 'lib-shared-api-utils';
import { ampli } from 'lib-shared-tracking';
import { memo } from 'react';

import { createSearchUrlParams } from 'app/views/layout/views/search/utils';
import { AppLink } from 'components/appLink';
import { mediaAttributes } from 'utils/channels/media';

import { useChannelDashboardChannelContext } from '../../channelDashboardChannel.context';

export const ChannelDashboardChannelTitle = memo(
  function ChannelDashboardChannelTitle(): JSX.Element {
    const { media, channels, isSkeleton } = useChannelDashboardChannelContext();

    return (
      <>
        {isSkeleton ? (
          <FlexBox alignItems="center" gap="250">
            <FlexBox
              justifyContent="center"
              alignItems="center"
              width="32px"
              height="32px"
            >
              <Skeleton height="18px" width="18px" />
            </FlexBox>

            <Skeleton height="20px" width="120px" />
          </FlexBox>
        ) : (
          <>
            <AppLink
              path="/search/conversations"
              params={createSearchUrlParams({
                filters: {
                  strategy: 'all',
                  filters: [
                    {
                      field: 'initial_channel',
                      operator: 'is_one',
                      values: channels.map((channel) => ({
                        value: convertChannelCasing(channel, 'truncate'),
                      })),
                    },
                    {
                      field: 'status',
                      operator: 'is_one',
                      values: [{ value: 'open' }],
                    },
                  ],
                },
              })}
              onClick={() => {
                ampli.dashboardChannelNameClicked();
              }}
            >
              <FlexBox alignItems="center" gap="200">
                <FlexBox alignItems="center" padding="200">
                  <Icon
                    name={mediaAttributes[media].icon}
                    color={typography.color.secondary}
                  />
                </FlexBox>

                <Text.Heading variant="heading-3">
                  {mediaAttributes[media].name}
                </Text.Heading>
              </FlexBox>
            </AppLink>
          </>
        )}
      </>
    );
  },
);
